import { queryOptions } from '@tanstack/react-query';
import { PdpInvestorDTO } from '@/types/models';
import { client } from '@/api/client';
export const pdpInvestors = async (id: number): Promise<PdpInvestorDTO[]> => {
  try {
    const result = await client.get(`/plans/${id}/investors`);
    return result.data.data;
  } catch (error) {
    return [] as PdpInvestorDTO[];
  }
};
export const pdpInvestorsOptions = (id: number) => queryOptions({
  queryKey: ['pdp-investors', id],
  queryFn: () => pdpInvestors(id)
});